import React from 'react';
import './Eligibility.css';

const Eligibility = () => {
  return (
    <section className="eligibility" id="eligibility">
      <div className="container">
        <h3 className="section-header">REQUIREMENTS</h3>
        <h2 className="section-title">
          ELIGIBILITY <span className="title-highlight">CRITERIA</span>
        </h2>
        
        <div className="eligibility-grid">
          <div className="eligibility-card">
            <div className="eligibility-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Minimum Age</h3>
            <p className="eligibility-value">17 YEARS</p>
          </div>
          <div className="eligibility-card">
            <div className="eligibility-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Education</h3>
            <p className="eligibility-value">12TH PASS</p>
          </div>
          <div className="eligibility-card">
            <div className="eligibility-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <path d="M12 15L8.5 18.5L9.5 13.5L5.5 10.5H10.5L12 5.5L13.5 10.5H18.5L14.5 13.5L15.5 18.5L12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <h3>Special Note</h3>
            <p className="eligibility-value">NO MATHS/PHYSICS REQUIRED</p>
          </div>
        </div>

        <div className="english-requirement">
          <div className="requirement-content">
            <div className="requirement-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <circle cx="12" cy="16" r="1" fill="currentColor"/>
              </svg>
            </div>
            <div className="requirement-text">
              <h3>English Proficiency Requirement</h3>
              <p>
                IELTS or English language proficiency test requirement is <span className="highlight-text">waived off for IB board students</span> and in some cases by university counselor upon evaluation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Eligibility;
